import Grid from '@mui/material/Grid';
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import IconButton from "@mui/material/IconButton";
import ListItemButton from "@mui/material/ListItemButton";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

import { makeStyles } from "@material-ui/core/styles";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { ListItemText } from '@mui/material';

import SelectProductAssignToClass from './SelectProductAssignToClass';
import Confirmation from "../../../Components/Modal/Confirmation";

const AssignProductToClass = (props) => {
    // Hooks
    const classes = useStyles();

    // Redux state
    let products = useSelector((state) => state.defs.siteConfig.products);

    // State    
    const [productId, setProductId] = useState(null);
    const [success, setSuccess] = useState(false);

    const handleProductAction = (id) => {
        setProductId(id);
    };

    return (
        <Grid 
            container 
            spacing={3} 
             
            sx={{height: '63vh', overflow: 'auto', px: 2 }}
        >
            <Grid item xs={6} sx={{ pb: 0.5 }}>
                {products && products.length > 0 && (
                    <>
                        {
                            products.map((obj, index) => {
                                return (
                                    <List
                                        onClick={() => { handleProductAction(obj.productId) }}
                                        sx={{ cursor: 'pointer' }}
                                        key={`${index}_product`} >
                                        <ListItemButton
                                            className={(obj.productId == productId) ? classes.activebox : classes.inactivebox}
                                            sx={{ border: 1, borderColor: '#D9D9D9', borderRadius: 10 }}
                                        >
                                            <ListItemText sx={{ borderRadius: 15 }}>
                                                <Typography variant="body2"
                                                    sx={{ fontWeight: '500', fontSize: '0.9rem', color: '#5f5600ff','@media (min-width: 1636px)': { fontSize: '1.4rem' } }}>
                                                    {/* {obj.productName}    */"Product"}
                                                </Typography>
                                            </ListItemText>                                            
                                            <IconButton>
                                                <Typography sx={{ color: (obj.productId == productId) ? '#9e9e9e' : '#9e9e9e', fontSize: '0.7vw', fontWeight: '500','@media (min-width: 1636px)': { fontSize: '1rem' } }}>More Info</Typography>
                                                <ArrowForwardIosIcon sx={{ fontSize: '0.8rem', color: (obj.productId == productId) ? '#9e9e9e' : '#9re9e9e','@media (min-width: 1636px)': { fontSize: '1rem' } }} />
                                            </IconButton>
                                        </ListItemButton>
                                    </List>
                                );
                            })
                        }
                    </>
                )}
            </Grid>
            {productId &&
                <Grid item xs={6} >
                    <SelectProductAssignToClass 
                        productId={productId} 
                        successConfirmation={(val) => { setSuccess(val) }} 
                    />
                </Grid>
            }            
            <Confirmation
              visible={success}
              primaryText="Updated product assign to class!"
              image="complete"
              alert={true}     
              toggleModal={(flag) => setSuccess(flag)}        
              timeout={2000}
            ></Confirmation>
        </Grid>
    );
};
const useStyles = makeStyles({
    activebox: {
        backgroundColor: '#D9D9D9',
        color: '#FFFFFF'
    },
    inactivebox: {
        backgroundColor: '#FFFFFF',
        color: '#DB8829',
    },
    scrollBar: {
        "&::-webkit-scrollbar": {
            width: "0.6em",
        },
        "&::-webkit-scrollbar-track": {
            backgroundColor: "#ffe600ff",
            "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
            borderRadius: 5,
        },
        "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#5f5600ff",
            borderRadius: 5,
        }
    }
});

export default AssignProductToClass;